import React, { useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer2";
import offerImage1 from "../../assets/images/offers-img1.jpeg";
import offerLogo1 from "../../assets/images/offer-logo1.png";
import LocationIcon from "../../assets/images/location.svg";
import PhoneIcon from "../../assets/images/phone.svg";
import LineRightIcon from "../../assets/images/lineRigtharrow.svg";
import RupeeIcon from "../../assets/images/gold_rupe_icon.svg";
import RedeemIcon from "../../assets/images/redeem.svg";
import MapImage from "../../assets/images/mapimage.svg";
import BackIcon from "../../assets/images/LineWhiteArrow.svg";
import LineIcon from "../../assets/images/line.svg";
import User from "../../assets/images/User-02.png";

import { fetchTermsAndCondition } from "../../redux/slice/offers/rewards";
import { issueRewardCall } from "../../redux/slice/offers/issueRewards";
import Spinner from "../../component/spinner/Spinner";
import "./StorePage.scss";

const StorePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  let mobile = localStorage.getItem("mobile");
  const offer = location?.state || {};
  const { termsAndConditionData } = useSelector((state) => state.rewards);
  const baseUrl = "https://d3kj4cuhkbykh5.cloudfront.net";
  const { issueRewardData, loading: issueRewardLoading } = useSelector(
    (state) => state.issueReward
  );

  // console.log(offer, "offer");

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
      onClick={() => navigate("/offers")}
    >
      Offers
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      {offer?.Offer_Name}
    </Typography>,
  ];

//   const handleIssueReward = async () => {
//     const data = {
//       mobile,
//       transactionNumber: Date.now(),
//       notes: `Redeemed points for ${offer?.Offer_Name}`,
//       brand: "DLFMallsDemo",
//     };
//     const result = await dispatch(issueRewardCall({ data, id: offer?.id }));
//     console.log(result, "result");

//     if (!result.payload.status.success) {
//       toast.error(result?.payload?.status?.message);
//     } else {
//       toast.success("Reward issued successfully");
//     }
//   };
  useEffect(() => {
    dispatch(fetchTermsAndCondition());
  }, []);
  return (
    <div>
      <Header />
      <div className="parent-container">
        <div
          className="container in-mobile desktop_content"
          style={{ paddingBottom: "8px" }}
        >
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="container">
          <div className="page-container1">
            <div
                style={{
                  backgroundImage: offer?.Offer_Image
                    ? `url(${baseUrl}${offer?.Offer_Image?.data?.attributes?.url})`
                    : `url(${User})`,
                }}
              className="offer1"
            >
              <div
                className="mobile_content back-content"
                onClick={() => navigate(-1)}
              >
                <img src={BackIcon} alt="back icon" width={10} height={24} />
                <p>{offer?.Offer_Name}</p>
              </div>
              <div className="gardient" style={{display:"none"}}>
                <div className="points-container">
                  {/* <div className="points1">
                    <img src={RupeeIcon} alt="rupee icon" />
                    <p>{offer?.intouchPoints} Points</p>
                  </div> */}
                  {/* <div className="points2">
                    <p className="with-span">
                      <span>Valid Till:</span>{" "}
                      {moment(offer?.endTime).format("DD MMM YYYY")}
                    </p>
                    <img
                      src={offer?.thumbnailUrl}
                      alt="logo"
                      className="logo"
                    />
                  </div> */}
                </div>
              </div>
            </div>
            <div className="offer2">
              <div className="title-container1">
                {/* <p className="title">{offer?.name}</p> */}
                <h4>{offer?.Offer_Name}</h4>
                <div className="address-container">
                  {/* <img
                    src={LocationIcon}
                    alt="Location icon"
                    width={22}
                    height={24}
                  /> */}
                  {/* <p style={{ textTransform: "capitalize" }}>
                    {offer?.Description || "N/A"}
                  </p> */}
                </div>
              </div>
              <div className="activate-container">
                {/* <button
                  onClick={() => {
                    handleIssueReward();
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Activate Offer {issueRewardLoading ? <Spinner /> : null}
                </button> */}
                {/* <div className="img-container">
                  <div>
                    <img
                      src={PhoneIcon}
                      alt="phone icon"
                      width={19}
                      height={19}
                    />
                  </div>
                  <div>
                    <img
                      src={LineRightIcon}
                      alt="line right icon"
                      width={15}
                      height={15}
                    />
                  </div>
                </div> */}
              </div>
              <div className="details-container1">
                <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ borderBottom: "1px solid #E4E4E4" }}
                  >
                    <h5>Offer detail</h5>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>{offer?.Description}</p>
                    <span className="valid">Valid Till: 24 March, 2026</span>
                  </AccordionDetails>
                </Accordion>

                {/* <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  className="directions"
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ borderBottom: "1px solid #E4E4E4" }}
                  >
                    <h5>Store directions</h5>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ paddingTop: "16px", paddingBottom: "16px" }}
                  >
                    <div className="directions-details">
                      <div
                        style={{
                          width: "300px",
                          height: "166px",
                          backgroundImage: `url(${MapImage})`,
                          backgroundSize: "cover",
                          margin: "0 auto 10px auto",
                        }}
                      ></div>
                      <div className="btn-container">
                        <button>
                          <img
                            src={PhoneIcon}
                            alt="phone icon"
                            width={15}
                            height={15}
                          />
                          <p>Call</p>
                        </button>
                        <button>
                          <img
                            src={LineRightIcon}
                            alt="line right icon"
                            width={15}
                            height={15}
                          />
                          <p>Direction</p>
                        </button>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion> */}

                <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  className="redeem"
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ borderBottom: "1px solid #E4E4E4" }}
                  >
                    <h5>How to Redeem</h5>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ paddingTop: "16px", paddingBottom: "16px" }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={LineIcon}
                        alt="line icon"
                        style={{
                          position: "absolute",
                          left: "22px",
                          height: "100%",
                        }}
                      />
                      <div className="redeem-detail">
                        <img src={RedeemIcon} alt="redeem icon" />
                        <div>
                          <h6>Select Offer</h6>
                          <p>Choose your favourite vouchers</p>
                        </div>
                      </div>
                      <div
                        className="redeem-detail"
                        style={{ margin: "32px 0" }}
                      >
                        <img src={RedeemIcon} alt="redeem icon" />
                        <div>
                          <h6>Redeem Offer</h6>
                          <p>Activate your selected vouchers</p>
                        </div>
                      </div>
                      <div className="redeem-detail">
                        <img src={RedeemIcon} alt="redeem icon" />
                        <div>
                          <h6>Claim Offer</h6>
                          <p>Claim the voucher copy at the concierge</p>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ borderBottom: "1px solid #E4E4E4" }}
                  >
                    <h5>Terms & Conditions</h5>
                  </AccordionSummary>
                  <AccordionDetails>
                    {termsAndConditionData?.split("\n")?.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className="fixed-btn"
       
      >
        <button
          onClick={() => {
            handleIssueReward();
          }}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Activate Offer {issueRewardLoading ? <Spinner /> : null}
        </button>
      </div> */}
      <Footer />
    </div>
  );
};

export default StorePage;
